import { SelectionDate, SelectionAny } from './internal';
export class SelectionCitationData extends SelectionAny {
    getDate() {
        return this.get("DATE" /* Tag.Date */, null, SelectionDate);
    }
    getText() {
        return this.get("TEXT" /* Tag.Text */);
    }
}
//# sourceMappingURL=SelectionCitationData.js.map